(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-qb"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ═══════════════════════════════════════
     QB - Header transparent :
     - mesure la barre d'annonce (offset top du header transparent)
     - toggle .qb-at-top sur <html> selon scroll position vs hauteur du hero
       → transparent + texte blanc quand au top, sinon couleurs natives Dawn
  ═══════════════════════════════════════ */
  (function () {
    if (!document.documentElement.classList.contains('qb-header-transparent')) return;

    var html = document.documentElement;
    var header = document.querySelector('.section-header');
    if (!header) return;

    function getUtilityBar() {
      var selectors = [
        '.shopify-section-group-header-group .utility-bar',
        '.utility-bar',
        '.shopify-section-group-header-group .announcement-bar-section',
        '.announcement-bar-section',
        '.shopify-section--announcement',
        '.shopify-section-announcement-bar'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetHeight > 0) return el;
      }
      var sections = document.querySelectorAll('.shopify-section');
      for (var j = 0; j < sections.length; j++) {
        if (sections[j] === header || sections[j].contains(header)) break;
        if (sections[j].offsetHeight > 0) return sections[j];
      }
      return null;
    }

    function updateUtilityBarHeight() {
      var bar = getUtilityBar();
      var h = bar ? bar.offsetHeight : 0;
      html.style.setProperty('--qb-utility-bar-height', h + 'px');
    }

    function getThreshold() {
      /* Hero = 1ère section APRÈS le header */
      var sections = document.querySelectorAll('.shopify-section');
      var headerSeen = false;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i] === header || sections[i].contains(header)) { headerSeen = true; continue; }
        if (headerSeen && sections[i].offsetHeight > 0) {
          return sections[i].offsetHeight - header.offsetHeight - 20;
        }
      }
      return 80;
    }

    var threshold = getThreshold();

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y < threshold) {
        html.classList.add('qb-at-top');
      } else {
        html.classList.remove('qb-at-top');
      }
    }

    function refresh() {
      updateUtilityBarHeight();
      threshold = getThreshold();
      onScroll();
    }

    /* Init : au top par défaut */
    html.classList.add('qb-at-top');

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    refresh();
  })();

  /* ═══════════════════════════════════════
     QB - Convention "pill" : titre [LABEL] dans Shopify
     ➜ ajoute la classe .header__menu-item--pill et retire les crochets
  ═══════════════════════════════════════ */
  (function () {
    var links = document.querySelectorAll('.header__inline-menu .list-menu--inline a span, .header__inline-menu .list-menu--inline summary span');
    links.forEach(function (span) {
      var txt = span.textContent.trim();
      if (txt.startsWith('[') && txt.endsWith(']') && txt.length > 2) {
        span.textContent = txt.slice(1, -1);
        var parent = span.closest('a, summary');
        if (parent) parent.classList.add('header__menu-item--pill');
      }
    });
  })();

  /* ═══════════════════════════════════════
     QB - Wishlist (localStorage)
     - Stocke les handles produits dans localStorage["qb_wishlist"]
     - Met à jour le compteur dans le header (.qb-wish-count-bubble)
     - Toggle l'état actif des boutons .qb-wish-toggle[data-product-handle]
     - API publique :
         window.QBWishlist.get()           → array de handles
         window.QBWishlist.add(handle)
         window.QBWishlist.remove(handle)
         window.QBWishlist.toggle(handle)
         window.QBWishlist.has(handle)     → boolean
         window.QBWishlist.clear()
         document.addEventListener('qb:wishlist:updated', function(e){...})
  ═══════════════════════════════════════ */
  (function () {
    var KEY = 'qb_wishlist';

    function read() {
      try {
        var raw = localStorage.getItem(KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('qb:wishlist:updated', { detail: { list: list } }));
    }

    function has(handle) { return read().indexOf(handle) >= 0; }

    function add(handle) {
      if (!handle) return;
      var list = read();
      if (list.indexOf(handle) < 0) { list.push(handle); write(list); }
    }

    function remove(handle) {
      var list = read();
      var i = list.indexOf(handle);
      if (i >= 0) { list.splice(i, 1); write(list); }
    }

    function toggle(handle) {
      if (!handle) return;
      var list = read();
      var i = list.indexOf(handle);
      if (i >= 0) list.splice(i, 1); else list.push(handle);
      write(list);
    }

    function clear() { write([]); }

    function updateBadge() {
      var count = read().length;
      document.querySelectorAll('.qb-wish-count-bubble').forEach(function (bubble) {
        var span = bubble.querySelector('span[aria-hidden]');
        if (span) span.textContent = count;
        if (count > 0) bubble.removeAttribute('hidden');
        else bubble.setAttribute('hidden', '');
        /* Filet de sécurité : force la position en inline style runtime
           pour battre tout reste de CSS Dawn (.cart-count-bubble bottom/left)
           même si le fichier section est servi depuis le cache CDN. */
        bubble.style.setProperty('position', 'absolute', 'important');
        bubble.style.setProperty('top', '0.4rem', 'important');
        bubble.style.setProperty('right', '0.4rem', 'important');
        bubble.style.setProperty('bottom', 'auto', 'important');
        bubble.style.setProperty('left', 'auto', 'important');
        bubble.style.setProperty('transform', 'none', 'important');
        bubble.style.setProperty('margin', '0', 'important');
        /* S'assurer que le parent a bien position: relative */
        var parent = bubble.parentElement;
        if (parent && parent.id === 'qb-wishlist-icon') {
          parent.style.setProperty('position', 'relative', 'important');
        }
      });
    }

    function updateButtons() {
      var list = read();
      document.querySelectorAll('.qb-wish-toggle[data-product-handle]').forEach(function (btn) {
        var h = btn.getAttribute('data-product-handle');
        var active = list.indexOf(h) >= 0;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    /* Délégation : un clic sur n'importe quel bouton .qb-wish-toggle */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qb-wish-toggle[data-product-handle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.getAttribute('data-product-handle'));
    });

    /* Sync au refresh storage (entre onglets) */
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) { updateButtons(); updateBadge(); }
    });

    document.addEventListener('qb:wishlist:updated', function () {
      updateButtons();
      updateBadge();
    });

    /* Init au chargement */
    function init() { updateButtons(); updateBadge(); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    /* Re-sync après chargement asynchrone (Section Rendering API, AJAX) */
    document.addEventListener('shopify:section:load', init);

    window.QBWishlist = { get: read, has: has, add: add, remove: remove, toggle: toggle, clear: clear };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ═══════════════════════════════════════
     QB - Header transparent :
     - mesure la barre d'annonce (offset top du header transparent)
     - toggle .qb-at-top sur <html> selon scroll position vs hauteur du hero
       → transparent + texte blanc quand au top, sinon couleurs natives Dawn
  ═══════════════════════════════════════ */
  (function () {
    if (!document.documentElement.classList.contains('qb-header-transparent')) return;

    var html = document.documentElement;
    var header = document.querySelector('.section-header');
    if (!header) return;

    function getUtilityBar() {
      var selectors = [
        '.shopify-section-group-header-group .utility-bar',
        '.utility-bar',
        '.shopify-section-group-header-group .announcement-bar-section',
        '.announcement-bar-section',
        '.shopify-section--announcement',
        '.shopify-section-announcement-bar'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetHeight > 0) return el;
      }
      var sections = document.querySelectorAll('.shopify-section');
      for (var j = 0; j < sections.length; j++) {
        if (sections[j] === header || sections[j].contains(header)) break;
        if (sections[j].offsetHeight > 0) return sections[j];
      }
      return null;
    }

    function updateUtilityBarHeight() {
      var bar = getUtilityBar();
      var h = bar ? bar.offsetHeight : 0;
      html.style.setProperty('--qb-utility-bar-height', h + 'px');
    }

    function getThreshold() {
      /* Hero = 1ère section APRÈS le header */
      var sections = document.querySelectorAll('.shopify-section');
      var headerSeen = false;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i] === header || sections[i].contains(header)) { headerSeen = true; continue; }
        if (headerSeen && sections[i].offsetHeight > 0) {
          return sections[i].offsetHeight - header.offsetHeight - 20;
        }
      }
      return 80;
    }

    var threshold = getThreshold();

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y < threshold) {
        html.classList.add('qb-at-top');
      } else {
        html.classList.remove('qb-at-top');
      }
    }

    function refresh() {
      updateUtilityBarHeight();
      threshold = getThreshold();
      onScroll();
    }

    /* Init : au top par défaut */
    html.classList.add('qb-at-top');

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    refresh();
  })();

  /* ═══════════════════════════════════════
     QB - Convention "pill" : titre [LABEL] dans Shopify
     ➜ ajoute la classe .header__menu-item--pill et retire les crochets
  ═══════════════════════════════════════ */
  (function () {
    var links = document.querySelectorAll('.header__inline-menu .list-menu--inline a span, .header__inline-menu .list-menu--inline summary span');
    links.forEach(function (span) {
      var txt = span.textContent.trim();
      if (txt.startsWith('[') && txt.endsWith(']') && txt.length > 2) {
        span.textContent = txt.slice(1, -1);
        var parent = span.closest('a, summary');
        if (parent) parent.classList.add('header__menu-item--pill');
      }
    });
  })();

  /* ═══════════════════════════════════════
     QB - Wishlist (localStorage)
     - Stocke les handles produits dans localStorage["qb_wishlist"]
     - Met à jour le compteur dans le header (.qb-wish-count-bubble)
     - Toggle l'état actif des boutons .qb-wish-toggle[data-product-handle]
     - API publique :
         window.QBWishlist.get()           → array de handles
         window.QBWishlist.add(handle)
         window.QBWishlist.remove(handle)
         window.QBWishlist.toggle(handle)
         window.QBWishlist.has(handle)     → boolean
         window.QBWishlist.clear()
         document.addEventListener('qb:wishlist:updated', function(e){...})
  ═══════════════════════════════════════ */
  (function () {
    var KEY = 'qb_wishlist';

    function read() {
      try {
        var raw = localStorage.getItem(KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('qb:wishlist:updated', { detail: { list: list } }));
    }

    function has(handle) { return read().indexOf(handle) >= 0; }

    function add(handle) {
      if (!handle) return;
      var list = read();
      if (list.indexOf(handle) < 0) { list.push(handle); write(list); }
    }

    function remove(handle) {
      var list = read();
      var i = list.indexOf(handle);
      if (i >= 0) { list.splice(i, 1); write(list); }
    }

    function toggle(handle) {
      if (!handle) return;
      var list = read();
      var i = list.indexOf(handle);
      if (i >= 0) list.splice(i, 1); else list.push(handle);
      write(list);
    }

    function clear() { write([]); }

    function updateBadge() {
      var count = read().length;
      document.querySelectorAll('.qb-wish-count-bubble').forEach(function (bubble) {
        var span = bubble.querySelector('span[aria-hidden]');
        if (span) span.textContent = count;
        if (count > 0) bubble.removeAttribute('hidden');
        else bubble.setAttribute('hidden', '');
      });
    }

    function updateButtons() {
      var list = read();
      document.querySelectorAll('.qb-wish-toggle[data-product-handle]').forEach(function (btn) {
        var h = btn.getAttribute('data-product-handle');
        var active = list.indexOf(h) >= 0;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    /* Délégation : un clic sur n'importe quel bouton .qb-wish-toggle */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qb-wish-toggle[data-product-handle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.getAttribute('data-product-handle'));
    });

    /* Sync au refresh storage (entre onglets) */
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) { updateButtons(); updateBadge(); }
    });

    document.addEventListener('qb:wishlist:updated', function () {
      updateButtons();
      updateBadge();
    });

    /* Init au chargement */
    function init() { updateButtons(); updateBadge(); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    /* Re-sync après chargement asynchrone (Section Rendering API, AJAX) */
    document.addEventListener('shopify:section:load', init);

    window.QBWishlist = { get: read, has: has, add: add, remove: remove, toggle: toggle, clear: clear };
  })();

  } catch(e) { console.error(e); }
})();
})();
